import { FC } from "react";
import { useTranslation } from "react-i18next";

import { LandingLayout, LoaderMuiLanding } from "@ryde/controls-landing";
import {
  CompanyScopeLandingsContextWrapper,
  ILandingPage,
  LandingCompanyIdEnum,
  useLandingInit,
} from "@ryde/utils-landings";

import { NvidiaShuttleWrapper } from "./nvidiashuttle-wrapper.styled";

export const NvidiaShuttlePage: FC<ILandingPage> = ({ companyId }) => {
  const { t } = useTranslation();
  const { landingInitData, isLoading } = useLandingInit({ companyId });
  return (
    <>
      {landingInitData && (
        <CompanyScopeLandingsContextWrapper
          companyId={landingInitData.companyId}
        >
          <NvidiaShuttleWrapper>
            <LandingLayout
              stepsContainerId={LandingCompanyIdEnum.NvidiaShuttle}
            />
          </NvidiaShuttleWrapper>
        </CompanyScopeLandingsContextWrapper>
      )}
      {isLoading && <LoaderMuiLanding loading text={t("ui.LOADING_DATA")} />}
    </>
  );
};
